import { useDispatch } from 'react-redux';
import { AppDispatch } from '../../Store';
import { IAuftrag } from '../../types/Types';
import { addToast } from '../../Slice/ToastSlice';



interface ThisProps {
  textToCopy: string;
  textToDisplay: string;
}

/**
 * @author noone
 */
const ButtonCopyComponent: React.FC<ThisProps> = (props) => {
  const dispatch = useDispatch<AppDispatch>();

  const copyAdresse = () => {
    if (navigator.clipboard && window.isSecureContext) {
      navigator.clipboard.writeText(props.textToCopy)
        //.then(() => alert("Text kopiert!"))
        .catch(err => console.error("Fehler beim Kopieren:", err));
      dispatch(addToast({
                message: `${props.textToCopy} wurde in die Zwischenablage kopiert.`,
                durationSeconds: 5,
              }));
    }
  }

  return (
    <>
      <button className="btn btn-light" onClick={() => copyAdresse()}>
        <i className="bi bi-copy"></i> {props.textToDisplay}
      </button>
    </>
  );

}

export default ButtonCopyComponent;